import { LOAN_TYPE_NAMES, LOAN_TYPES } from '~/typings/enums/LoanType';

const SUGGESTED_EXCEPTIONS = ['CASHBACK_KEEP_INSTALLMENT_VALUE', 'INSTALLMENT_VALUE_CUT', 'MAX_CASHBACK'];

// O suggestedOfferType da portabilidade INSS (PORT_WITH_MARGIN/PORT_WITHOUT_MARGIN) também vira "Portabilidade",
// então nesses loanTypes o próprio loanType decide o nome para não confundir com a portabilidade com refin.
const LOAN_TYPES_OVER_SUGGESTED = [LOAN_TYPES.PORTABILITYWITHOUTREFIN];

function loanTypeName(loanType: string, suggestedName?: string): string {
  const suggestedDecidesName = suggestedName && !SUGGESTED_EXCEPTIONS.includes(suggestedName);

  if (suggestedDecidesName && !LOAN_TYPES_OVER_SUGGESTED.includes(loanType)) {
    return LOAN_TYPE_NAMES?.[suggestedName] || suggestedName;
  }

  if (loanType) {
    return LOAN_TYPE_NAMES?.[loanType] || loanType;
  }

  return null;
}

export default loanTypeName;
